//import './modules/bootstrap.modules.js';
import mobileNav from './modules/mobileNav';
import accessibleMenu from './modules/accesibleMenu';
import scrolled from './modules/scrolled';
import backToTop from './modules/backToTop';
import searchhandler from './modules/searchHandler';
import { initDeviceDetector } from './modules/deviceDetector';

function initModules() {
	mobileNav();
	accessibleMenu();
	scrolled();
	backToTop();
	initDeviceDetector();
	searchhandler();
}

function cleanTypes() {
	document.querySelectorAll('script, style').forEach((el) => {
		el.removeAttribute('type');
	});
}

document.addEventListener('DOMContentLoaded', () => {
	initModules();
	cleanTypes();

	// Lazy-load slider only if needed
	// if (document.querySelector('.slider')) {
	//   import('./components/tinySlider').then((module) => module.default());
	// }

	// smoothScroll() could be lazy-loaded similarly
});
